// src/app/shared/components/header/header.component.ts
import { Component, OnInit, OnDestroy } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export default class HeaderComponent implements OnInit, OnDestroy {
  isMobileView: boolean = false;
  isTabletView: boolean = false;
  isDesktopView: boolean = false;
  mobileMenuOpen: boolean = false;
  desktopMenuOpen: string | null = null;
  mobileSubmenuOpen: string | null = null;

  menus: Menu[] = [
    {
      path: '/home',
      label: 'Home',
      showOnDesktop: true,
    },
    {
      path: '/about',
      label: 'Sobre nosotros',
      showOnDesktop: true,
    },
    {
      label: 'Servicios',
      showOnDesktop: true,
      child: [
        { path: '/servicios/financiamiento', label: 'Financiamiento y Mercado de Capitales' },
        { path: '/servicios/tesoreria', label: 'Tesorería y Gestión del Capital' },
        { path: '/servicios/external-cfo', label: 'External CFO (Outsourcing)' },
        { path: '/servicios/capacitacion', label: 'Capacitación Educativa y Empresarial' },
        { path: '/servicios/comex', label: 'Comercio Exterior (COMEX)' },
        { path: '/servicios/consultoria-fiscal', label: 'Consultoría Fiscal y Legal' },
        { path: '/servicios/servicios-especializados', label: 'Servicios Especializados' }
      ]
    },
    {
      path: '/calculadora-cheques',
      label: 'Calculadora de cheques',
      showOnDesktop: true,
    },
  ];

  private destroy$: Subject<void> = new Subject<void>();

  constructor(private breakpointObserver: BreakpointObserver) { }

  toggleDesktopMenu(label: string): void {
    this.desktopMenuOpen =
      this.desktopMenuOpen === label ? null : label;
  }

  ngOnInit() {
    this.breakpointObserver.observe([Breakpoints.HandsetPortrait, Breakpoints.HandsetLandscape])
      .pipe(takeUntil(this.destroy$)).subscribe(result => this.isMobileView = result.matches);

    this.breakpointObserver.observe([Breakpoints.TabletPortrait, Breakpoints.TabletLandscape])
      .pipe(takeUntil(this.destroy$)).subscribe(result => this.isTabletView = result.matches);

    this.breakpointObserver.observe([Breakpoints.WebPortrait, Breakpoints.WebLandscape])
      .pipe(takeUntil(this.destroy$)).subscribe(result => this.isDesktopView = result.matches);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}

export interface Menu {
  path?: string;
  label: string;
  child?: Menu[]; // 👈 Asegúrate de que esta propiedad exista en tu interfaz
  showOnMobile?: boolean;
  showOnTablet?: boolean;
  showOnDesktop?: boolean;
}